export default "__VITE_ASSET__AJ3QHEfR__"